import React, { Component } from "react";
// import Layout from "../../components/layout";
import Breadcrumbs from "../../components/breadcrumbs";
import CustomHelmet from "../../components/customHelmet";
//import PageHeading from "../../../components/pageHeading";
//import ReCAPTCHA from "react-google-recaptcha";
import { host, reCaptchaKey, captchaURL, isDevEnvironment } from "../../helpers/commons";

import cx from "classnames";
import Styles from "./assets/BrokerLogin.module.css"
import logo from "../../assets/images/logo.png";

class BrokerLogin extends Component {
    constructor(props) {
        super(props);
        //const params = new URLSearchParams(window.location.search);

        this.state = {
            email: "",
            otp: "",
            otpSent: false,
            otpVerified: false,
            loading: false,
            loadingPage: true,
            message: "",
            messageClass: "",
            profile_pic: "https://marketplace.hashfinancialgroup.com/site-assets/profile-pic.png?v=1.0",
            recaptchaToken: null,
            resendTimer: 0,
            remember_me: 0,
        };
        this.recaptchaRef = React.createRef();
    }

    handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;

        if (type === "checkbox") {
            this.setState({ [name]: checked ? 1 : 0 });
        } else {
            this.setState({ [name]: value });
        }
    };


    // handleCaptchaChange = (token) => {
    //     this.setState({ recaptchaToken: token });
    // };

    sendOTP = async () => {
        const { email } = this.state;

        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            this.setState({ message: "Please enter a valid email." });
            return;
        }

        // if (!recaptchaToken) {
        //     this.setState({ message: "Please verify the CAPTCHA." });
        //     return;
        // }

        this.setState({ loading: true, message: "" });

        try {
            const response = await fetch(host + "/gatsby-api/send-otp", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: `email=${encodeURIComponent(email)}`
            });

            const data = await response.json();
            if (data.success) {
                this.setState({ otpSent: true, message: "OTP sent to your email.", resendTimer: 3, messageClass: "alert-info" });

                let countdown = 180;

                const timer = setInterval(() => {
                    let minutes = Math.floor(countdown / 60);
                    let seconds = countdown % 60;

                    let displayTime = `${minutes}:${seconds.toString().padStart(2, "0")}`;

                    //console.log(displayTime); 

                    this.setState({ resendTimer: displayTime });

                    countdown--;

                    if (countdown <= 0) {
                        clearInterval(timer);
                        this.setState({ resendTimer: 0 });
                    }
                }, 1000);
            } else {
                this.setState({ message: data.data.message || "Failed to send OTP.", messageClass: "alert-danger" });
            }
        } catch (error) {
            this.setState({ message: "Error sending OTP. Please try again." });
        }

        this.setState({ loading: false });
        if (this.recaptchaRef.current) this.recaptchaRef.current.reset();
    };

    verifyOTP = async () => {
        const { email, otp, recaptchaToken, remember_me } = this.state;
        this.setState({ loading: true, message: "" });

        //const recaptchaToken = await grecaptcha.execute("6Le7kdoqAAAAAL6m7VHG9hNVM1skvFYsvbFu_BPO", { action: "login" });

        const formData = new URLSearchParams();
        formData.append("email", email);
        formData.append("otp", otp);
        formData.append("remember_me", remember_me);
        formData.append("recaptcha_token", recaptchaToken);
        // console.log(formData);
        // return;
        //console.log("Generated reCAPTCHA Token:", this.state.recaptchaToken); return;

        if (!recaptchaToken) {
            console.error("reCAPTCHA token is missing!");
            return;
        }

        try {
            const response = await fetch(host + "/gatsby-api/validate-otp", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formData.toString(),
            });

            const data = await response.json();

            if (data.success) {
                // document.cookie = `broker_session=${data.tid}; path=/; domain=.hashfinancialgroup.com; secure; HttpsOnly; samesite=None;`;
                const isLocalhost = window.location.hostname === "localhost";
                document.cookie = `broker_session=${data.tid}; path=/; ${isLocalhost 
                ? "" 
                : "domain=.hashfinancialgroup.com; secure; SameSite=None;"}`;
                
                this.setState({ otpVerified: true, message: "" });
                window.location.href = "/broker/profile";
            } else {
                this.setState({ message: data.message || "Account verification failed. Please try again later.", messageClass: "alert-danger" });
            }
        } catch (error) {
            this.setState({ message: "Account verification failed. Please try again later.", messageClass: "alert-danger" });
        }

        this.setState({ loading: false });
    };

    loadRecaptcha = () => {
        const interval = setInterval(() => {
            if (window.grecaptcha && window.grecaptcha.ready) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(reCaptchaKey, { action: "login" })
                        .then(token => this.setState({ recaptchaToken: token }));
                });
                clearInterval(interval); // Stop checking once it's loaded
            }
        }, 1000);
    };

    async componentDidMount() {
        // try {
        //     const response = await fetch(host + "/gatsby-api/validate-session", {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json",
        //             "Authorization": `Bearer ${sessionToken}`
        //         }
        //     });

        //     const data = await response.json();
        //     if (data.success) {
        //         this.setState({ isLoggedIn: true, brokerData: data.broker, loading: false });
        //         window.location.href = "/broker/profile";
        //     } else {
        //         this.cookies.remove("broker_session");
        //         this.setState({ isLoggedIn: false, loading: false });                
        //     }
        // } catch (error) {
        //     this.setState({ isLoggedIn: false, loading: false, message: "Error fetching profile." });
        // }        

        this.loadRecaptcha();

        if (typeof window !== "undefined") {
            const params = new URLSearchParams(window.location.search);
            this.setState({ email: params.get("email") || "" });
        }

        try {
            const response = await fetch(host + "/gatsby-api/validate-session", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            const data = await response.json();

            if (data.success) {
                // this.setState({ isLoggedIn: true, brokerData: data.data, loading: false });
                window.location.href = "/broker/profile";
            } else {
                this.setState({ isLoggedIn: false, loading: false, loadingPage:false });
            }
        } catch (error) {
            this.setState({ isLoggedIn: false, loading: false, message: "Something went wrong.", messageClass: "alert-danger" });
        }
    }

    render() {
        const { email, otp, otpSent, resendTimer, otpVerified, loading, message, messageClass, remember_me, loadingPage } = this.state;
        let breadcrumbs = [{ name: "Broker Login", link: "" }];

        return (
            <>
                <CustomHelmet>
                    <title>Broker Login</title>
                    <meta name="description" content="Login to access your broker profile." />
                    <script src={captchaURL}></script>
                </CustomHelmet>
                {loadingPage ? (
                    <div className="page-loader" style={{ height: "100vh" }}>Loading...</div>
                ) : (
                    <main className={cx(Styles.brokerMain, "d-flex align-items-center justify-content-center")}>
                        <div className={cx(Styles.loginPanel, "container")}>
                            <div className="row">
                                <div className="col-md-4 mx-auto text-center">
                                    <img className="mb-4" src={logo} alt="Hash Financial Group" />
                                    <h1 className="h3 mb-3 fw-normal">HFG Marketplace</h1>
                                    <div className="card">
                                        <div className="card-body">
                                            <p>Please sign-in to your account:</p>
                                            {!otpVerified ? (
                                                <>
                                                    <div className="form-group">
                                                        {/* <label>Email:</label> */}
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            className="form-control"
                                                            value={email}
                                                            placeholder="Enter your registered email"
                                                            onChange={this.handleInputChange}
                                                            disabled={otpSent}
                                                        />
                                                    </div>

                                                    {!otpSent && (
                                                        <>
                                                            {/* <ReCAPTCHA
                                                        sitekey={reCaptchaKey}
                                                        onChange={this.handleCaptchaChange}
                                                        ref={this.recaptchaRef}
                                                    /> */}
                                                            <button
                                                                className="btn btn-primary mt-1 mb-3 w-100"
                                                                onClick={this.sendOTP}
                                                                disabled={loading}
                                                            >
                                                                {loading ? "Sending OTP..." : "Send OTP"}
                                                            </button>
                                                        </>
                                                    )}

                                                    {otpSent && (
                                                        <div>
                                                            <div className="form-group mt-3">
                                                                <label>Enter OTP:</label>
                                                                <input
                                                                    type="text"
                                                                    name="otp"
                                                                    className="form-control"
                                                                    value={otp}
                                                                    onChange={this.handleInputChange}
                                                                />
                                                            </div>

                                                            <div className="form-group mt-3">
                                                                <input
                                                                    type="checkbox"
                                                                    name="remember_me"
                                                                    value={remember_me}
                                                                    onChange={this.handleInputChange}
                                                                /> Remember me
                                                            </div>

                                                            <button
                                                                className="btn btn-success w-100"
                                                                onClick={this.verifyOTP}
                                                                disabled={loading}
                                                            >
                                                                {loading ? "Verifying OTP..." : "Verify OTP"}
                                                            </button>
                                                            <p className="text-center">
                                                                {resendTimer != 0 ? (<button
                                                                    className={cx("btn mt-1", Styles.btnResend)}
                                                                    disabled="true"
                                                                >
                                                                    Resend in {resendTimer} mins
                                                                </button>) : (
                                                                    <button
                                                                        className={cx("btn mt-1", Styles.btnResend)}
                                                                        onClick={this.sendOTP}
                                                                    >
                                                                        Resend OTP
                                                                    </button>
                                                                )}
                                                            </p>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="alert alert-success">You are logged in!</div>
                                            )}

                                            {message && <div className={cx(messageClass, "alert")}>{message}</div>}
                                        </div>
                                    </div>
                                    <div className={cx("text-center mt-5", Styles.registerAccount)}>
                                        <h6>New to the HFG Marketplace?</h6>
                                        <a href="/broker/register">Create a broker account</a> to showcase your business profile and connect with clients.
                                    </div>
                                    <div className={cx("text-center mt-5", Styles.loginFooter)}>
                                        &copy; {new Date().getFullYear()} Hash Financial Group
                                    </div>
                                </div>{/** login container */}
                            </div>
                        </div>
                    </main>
                )};
            </>
        );
    }
}

export default BrokerLogin;
